import { BrowserBranding } from "./types.ts";
import logoSquareSvg from "../assets/white-label/logo-square.svg";
import loadingSquareAnimation from "../assets/white-label/loading-logo-square.svg";
import logoSquareBitmap from "../assets/white-label/logo.png";
import purposeMyself from "../assets/white-label/get-started/whositfor-myself.png";
import purposeGift from "../assets/white-label/get-started/whosifor-gift.png";
import giftTypeBrickMosaic from "../assets/white-label/get-started/typeofgift-brickmosaic.png";
import giftTypeGiftCard from "../assets/white-label/get-started/typeofgift-giftcard.png";
import giftChooserIChoose from "../assets/white-label/get-started/typeofgift-ichoose.png";
import giftChooserTheyChoose from "../assets/white-label/get-started/typeofgift-theychoose.png";

function createWhiteLabelBrowserBranding(): BrowserBranding {
	return {
		showPoweredBy: true,
		companyName: "Brick My Story",
		domainName: "brickmystory.com",
		logoSquareSvg,
		loadingSquareAnimation,
		logoSquareBitmap,
		giftCardProductPath: "/products/brickmystory-gift-card",
		mosaicGiftPagePath: "/pages/mosaic-gift",
		readOurTipsPath:
			"/pages/what-works-best-when-transforming-photos-into-brick-mosaics",
		contactPagePath:
			"/pages/what-works-best-when-transforming-photos-into-brick-mosaics",
		faqPagePath:
			"/pages/what-works-best-when-transforming-photos-into-brick-mosaics",
		designItForMeProductPath: "/products/design-for-me",
		watchTutorialPagePath:
			"/pages/what-works-best-when-transforming-photos-into-brick-mosaics",
		picsToBrickTipsHeading:
			"What works best when transforming photos into brick mosaics?",
		assemblyInfoHtml: [
			"<p>Your Custom Mosaic, Ready to Display</p>",
			"<p>Unpacking a creative project is exciting, but sometimes you just want the finished masterpiece in your hands. Whether you are hunting for an unforgettable, ready-to-give gift, or your schedule simply doesn't leave room for a DIY project, our <strong>Build It For Me</strong> feature is the perfect solution.</p>",
			"<p>For a small additional fee, our team will meticulously assemble your custom brick mosaic before it ever leaves our workshop. Instead of a box of loose pieces, you'll receive a stunning, fully constructed piece of art that is ready to be mounted on your wall the moment you unbox it. Skip the building process and jump straight to the breathtaking results - ideal for busy professionals, thoughtful gifters, or anyone who prefers to leave the assembly to the experts.</p>",
		].join(""),
		showBrickMosaicGiftOption: false,
		showGiftCardAmountText: false,
		minimumGiftCardAmount: 500,
		getStartedImages: {
			purposeMyself,
			purposeGift,
			giftTypeBrickMosaic,
			giftTypeGiftCard,
			giftChooserIChoose,
			giftChooserTheyChoose,
		},
	};
}

export { createWhiteLabelBrowserBranding };
